__turbopack_context__.v({
  "alert": "hoc-tap-login-modal-module__I7VWQG__alert",
  "alertError": "hoc-tap-login-modal-module__I7VWQG__alertError",
  "alertInfo": "hoc-tap-login-modal-module__I7VWQG__alertInfo",
  "alertSuccess": "hoc-tap-login-modal-module__I7VWQG__alertSuccess",
  "backdrop": "hoc-tap-login-modal-module__I7VWQG__backdrop",
  "checkboxLabel": "hoc-tap-login-modal-module__I7VWQG__checkboxLabel",
  "closeButton": "hoc-tap-login-modal-module__I7VWQG__closeButton",
  "fadeIn": "hoc-tap-login-modal-module__I7VWQG__fadeIn",
  "field": "hoc-tap-login-modal-module__I7VWQG__field",
  "forgotBtn": "hoc-tap-login-modal-module__I7VWQG__forgotBtn",
  "form": "hoc-tap-login-modal-module__I7VWQG__form",
  "formOptions": "hoc-tap-login-modal-module__I7VWQG__formOptions",
  "header": "hoc-tap-login-modal-module__I7VWQG__header",
  "iconBadge": "hoc-tap-login-modal-module__I7VWQG__iconBadge",
  "input": "hoc-tap-login-modal-module__I7VWQG__input",
  "inputWrap": "hoc-tap-login-modal-module__I7VWQG__inputWrap",
  "loadingSpinnerWrap": "hoc-tap-login-modal-module__I7VWQG__loadingSpinnerWrap",
  "modalCard": "hoc-tap-login-modal-module__I7VWQG__modalCard",
  "passwordInput": "hoc-tap-login-modal-module__I7VWQG__passwordInput",
  "registerFooter": "hoc-tap-login-modal-module__I7VWQG__registerFooter",
  "scaleUp": "hoc-tap-login-modal-module__I7VWQG__scaleUp",
  "spin": "hoc-tap-login-modal-module__I7VWQG__spin",
  "spinner": "hoc-tap-login-modal-module__I7VWQG__spinner",
  "submitBtn": "hoc-tap-login-modal-module__I7VWQG__submitBtn",
  "subtitle": "hoc-tap-login-modal-module__I7VWQG__subtitle",
  "termsLabel": "hoc-tap-login-modal-module__I7VWQG__termsLabel",
  "title": "hoc-tap-login-modal-module__I7VWQG__title",
  "togglePasswordBtn": "hoc-tap-login-modal-module__I7VWQG__togglePasswordBtn",
});
